// directives/glow.ts
import { DirectiveBinding } from 'vue';

export const primaryBorder = {
  mounted(el: HTMLElement, binding: DirectiveBinding<boolean>) {
    if (binding.value) {
      el.classList.add('border-primary');
    }
  },
  updated(el: HTMLElement, binding: DirectiveBinding<boolean>) {
    if (binding.value !== binding.oldValue) {
      if (binding.value) {
        el.classList.add('border-primary');
      } else {
        el.classList.remove('border-primary');
      }
    }
  }
};
